import { combineReducers } from "redux";
import restaurant from "./restaurant.reducer";
import request from "./request.reducer";

export default combineReducers({
  restaurant,
  request,
});
